import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import request from "../helpers/request";

const STORAGE_KEY = "painel_api_key";

export const usePainelPublico = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [apiKey, setApiKey] = useState<string | null>(null);
  const [status, setStatus] = useState<"loading" | "ready" | "unauthorized">(
    "loading",
  );
  const [data, setData] = useState<any>(null);

  const fetchConfig = async (key: string) => {
    console.log("Buscando configurações com a chave:", key);
    try {
      const url = `${process.env.REACT_APP_API}/AcessoExterno/Configuracoes`;
      const result = await request({
        url,
        apiKey: key,
      });
      setData(result.data);
      setStatus("ready");
    } catch (error) {
      console.error("Erro ao buscar configurações:", error);
      setStatus("unauthorized");
    }
  };

  useEffect(() => {
    const keyFromUrl = searchParams.get("apikey");

    if (keyFromUrl) {
      localStorage.setItem(STORAGE_KEY, keyFromUrl);

      const newParams = new URLSearchParams(searchParams);
      newParams.delete("apikey");

      navigate(
        {
          pathname: location.pathname,
          search: newParams.toString(),
        },
        { replace: true },
      );

      setApiKey(keyFromUrl);
      fetchConfig(keyFromUrl);
      return;
    }

    const keyFromStorage = localStorage.getItem(STORAGE_KEY);
    if (keyFromStorage) {
      setApiKey(keyFromStorage);
      fetchConfig(keyFromStorage);
    } else {
      setStatus("unauthorized");
    }
  }, [navigate, searchParams, location.pathname]);

  const revogarAcesso = () => {
    localStorage.removeItem(STORAGE_KEY);
    setApiKey(null);
    setData(null);
    setStatus("unauthorized");
  };

  return { apiKey, status, revogarAcesso, data };
};
